import CommandsPool from "@kaspernj/api-maker/build/commands-pool"
import I18n from "shared/i18n"

const setLayout = (layout) => {
  const commandsPool = CommandsPool.current()

  if (!commandsPool.globalRequestData) commandsPool.globalRequestData = {}

  commandsPool.globalRequestData.layout = layout
  commandsPool.globalRequestData.locale = I18n.locale
  commandsPool.globalRequestData.super_admin = false
  commandsPool.globalRequestData.url = globalThis.location?.href
  commandsPool.globalRequestData.url_referer = globalThis.document?.referrer || null
}

export default setLayout
